import { ENRICHMENT_ANSWER_TYPE_URL } from "../enrichmentAnswerTypes";

export function isEnrichmentAnswerTypeUrl(enrichment) {
    return enrichment.answer_type == ENRICHMENT_ANSWER_TYPE_URL;
}
